import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { gql } from '@/__generated__';
import { makeSsrApolloClient } from '@/apollo/ssr-apollo-client';
import { mentionsBlockedTerm } from '../sitemap[.]xml/blocked-terms';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap';

const PublicTournamentsQuery = gql(`
  query PublicTournaments($limit: Int, $nextToken: String, $closed: Boolean) {
    publicTournaments(limit: $limit, nextToken: $nextToken, closed: $closed) {
      items {
        id
        name
      }
      nextToken
    }
  }`);

const getTournaments = async (
  client: ApolloClient<NormalizedCacheObject>,
  { closed }: { closed: boolean },
) => {
  const allItems: { id: string; name: string }[] = [];
  let nextToken;

  do {
    const { data, error } = await client.query({
      query: PublicTournamentsQuery,
      variables: { limit: 1000, nextToken: null, closed },
    });

    if (error) {
      throw error;
    }

    allItems.push(...data.publicTournaments.items);
    nextToken = data.publicTournaments.nextToken;
  } while (nextToken);

  return allItems;
};

export const tournamentSitemap: SeoHandle['sitemap'] = async () => {
  const client = makeSsrApolloClient();

  const [activeTournaments, closedTournaments] = await Promise.all([
    getTournaments(client, { closed: false }),
    getTournaments(client, { closed: true }),
  ]);

  return [...activeTournaments, ...closedTournaments]
    .filter(({ name }) => !mentionsBlockedTerm(name))
    .map(({ id }) => ({
      path: `p/tournaments/${id}`,
    }));
};
